import React, { Component } from "react";

import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardImage,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBBtn,
  Button,
} from "mdbreact";
import { Card, CardHeader } from "reactstrap";
import { Typography, Container } from "@material-ui/core";
import BreadCumb from "../Department/BreadCumb";
import BreadCrumbOwn from "../Essentials/BreadCrumbOwn";

export default class GeneralRule extends Component {
  render() {
    return (
      <div>
        <BreadCrumbOwn title="Dispur College At A Glance" />
        <Container>
          <br />

          <div>
            <Typography variant="body1" gutterBottom>
              Established in 1978, Dispur College is one of the premier
              institutions of higher education in Assam, affiliated with Gauhati
              University. Located in the heart of Guwahati, the primary urban
              center of Assam as well as the gateway to North-Eastern India, the
              College has consistently strived to deliver quality education
              while fostering the holistic development of its students.
              <br/><br/>
               With a
              commitment to academic excellence and inclusive growth, Dispur
              College offers Higher Secondary programme in Arts and Commerce
              streams, along with undergraduate courses in Arts, Commerce, and
              Professional Studies. From the academic session 2026–27, the
              College is set to expand its academic horizon by introducing
              postgraduate programmes in Political Science, Philosophy,
              Commerce, and MBA, as well as the Integrated Teacher Education
              Programme (ITEP). In addition, the institution also offers several
              certificate and skill-based courses designed to meet contemporary
              educational and professional demands.
              <br/><br/> The College is widely
              recognised for its dedicated faculty, vibrant student community,
              and strong emphasis on co-curricular and extracurricular
              engagement. Over the years, Dispur College has earned a reputation
              as a centre for nurturing critical thinking, leadership, and
              social responsibility. It actively promotes intellectual
              engagement through seminars, debates, workshops, and cultural
              events, encouraging students to articulate their ideas and
              contribute meaningfully to society.
            </Typography>
            <br/>
        
          </div>
        </Container>
      </div>
    );
  }
}
